// Analytics initialization for Google Analytics 4 + Microsoft Clarity.
// Both are gated on env vars — if no ID is set, the script no-ops gracefully.

const GA_ID = process.env.REACT_APP_GA_ID || "";
const CLARITY_ID = process.env.REACT_APP_CLARITY_ID || "";

let gaInitialized = false;
let clarityInitialized = false;

export function initAnalytics() {
  if (typeof window === "undefined") return;

  // ----- Google Analytics 4 -----
  if (GA_ID && !gaInitialized) {
    gaInitialized = true;
    // Load gtag.js
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line no-inner-declarations
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag("js", new Date());
    // send_page_view: false because we send manually on route changes
    gtag("config", GA_ID, { send_page_view: false });
  }

  // ----- Microsoft Clarity -----
  if (CLARITY_ID && !clarityInitialized) {
    clarityInitialized = true;
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", CLARITY_ID);
  }
}

export function trackPageView(path) {
  if (typeof window === "undefined") return;
  if (GA_ID && window.gtag) {
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }
}

// Fire a custom event to any wired analytics/retargeting platform.
// GA4 records it as an event you can use to build audiences (e.g. "started
// scorecard but didn't complete") and drive retargeting campaigns.
// Microsoft Clarity also receives it as a custom tag so session replays
// filter by these behaviours.
export function trackEvent(name, params = {}) {
  if (typeof window === "undefined" || !name) return;
  if (GA_ID && window.gtag) {
    window.gtag("event", name, params);
  }
  if (CLARITY_ID && window.clarity) {
    try {
      window.clarity("event", name);
      Object.entries(params).forEach(([k, v]) => {
        if (v !== undefined && v !== null) window.clarity("set", k, String(v));
      });
    } catch (_) { /* clarity not fully initialised yet — safe to swallow */ }
  }
}
